<template>
    <div id="app" v-bind:class="cssClass()">

        <Menu v-on:close="hideMenu"></Menu>

        <div class="main" id="main">

            <page-header v-on:toggleMenu="toggleMenu"></page-header>

            <router-view />

            <page-footer></page-footer>

        </div>
        <svg-asset icon="symbols"></svg-asset>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
   
    import PageHeader from '@/components/PageHeader';
    import PageFooter from '@/components/PageFooter';
    import Menu from '@/components/Menu';
    import SvgAsset from '@/components/SvgAsset';

    export default {
        name: 'app',
        components: {
            PageHeader,
            PageFooter,
            Menu,
            SvgAsset
        },
        computed: mapState([
            'ready',
            'menu',
            'color'
        ]),
        watch: {
            $route (to, from){
                this.hideMenu();            
            },            
            menu(value) {
                const menu = document.getElementById('menu');
                const main = document.getElementById('main');
                if(value) {
                    let width = window.outerWidth;
                    if(width >= 640) {
                        width = 275;
                    }
                    menu.style.width = width + 'px';

                    
                    main.style.marginLeft = width + 'px'
                    main.style.marginRight = -width + 'px'

                    main.style.width = main.offsetWidth + 'px';
                } else {
                    menu.style.width = '0';

                    main.style.marginLeft = '0';
                    main.style.marginRight = '0';
                    main.style.width = 'auto';                    
                }
            },
        },
        methods: {
            ...mapActions([
                'toggleMenu',
                'hideMenu',
                'noHeroImage']),
            cssClass() {
                let classes = { 'menu--open': this.menu };
                if(this.color) {
                    classes['bg-color'] = true;
                    classes['bg2-color-' + this.color] = true;
                }
                return classes;
            },
        }
    }
</script>

<style lang="scss">
    @import '@/scss/app.scss';

    #app {
        height: 100%;
    }

    .menu {
        height: 100%;
        position: fixed;
        z-index: 1;
        top: 0;
        left: 0;
        width:0;
        overflow-x: hidden;
        transition: 0.5s;
    }

    .main {
        height: 100%;
        transition: margin-left .5s;
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
    }

    /*.menu--open {
        //background-color: rgba(0, 0, 0, 0.3);
    }*/

    .content {
        flex-grow: 1;
        flex-direction: column;

        display: flex;
        flex-direction: column;
        align-items: center;

        padding-top:46px;
    }

</style>